import React, { useEffect } from 'react';
import MarginalWeather from './components/marginal-weather/MarginalWeather';
import { AuthProvider, useAuth } from './context/authContext/AuthContext';
import { onSignIn, onSignOut } from './utils/AuthFunctionUtils';
import { AppInsightProvider } from './context/appInsightContext/AppInsightContext';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

const App: React.FC = () => {
  return (
    <div className="App">
      <AuthProvider onSignIn={onSignIn} onSignOut={onSignOut}>
        <AppInsightProvider>
          <AppRoutes />
        </AppInsightProvider>
      </AuthProvider>
    </div>
  );
};

const AppRoutes: React.FC = () => {
  const { isAuthenticated, isLoading, userData } = useAuth();
  useEffect(() => {
    if (!isLoading && userData) {
      const currentUrl = window.location.href;
      const baseUrl = currentUrl.split("/Callback")[0];
      window.history.replaceState({}, document.title, baseUrl);
    }
  }, [isAuthenticated, isLoading, userData]);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/MarginalWeather" element={<MarginalWeather />} />
        <Route path="/MarginalWeather/Callback" element={<MarginalWeather />} />
        <Route path="*" element={<Navigate to="/MarginalWeather" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
